import { Link } from 'react-router-dom';
import { HttpStatusCode } from '@sib/api';
import { Button } from '@sib/ui';
import { InformationWrapper } from '@sib/ui';
import { DocumentNotFound as DocumentNotFoundIcon } from '@sib/ui/icons';
import { paths } from '@spendbrain/config/paths';
import { useAppTranslation } from '../../hooks';

export const DocumentNotFound = () => {
  const { t } = useAppTranslation();

  return (
    <InformationWrapper
      icon={<DocumentNotFoundIcon className="text-primary size-27" />}
      title={`${HttpStatusCode.NotFound} ${t('components.documentPreview.documentNotFound.title')}`}
      description={t('components.documentPreview.documentNotFound.description')}
      footer={
        <div className="flex items-center justify-center gap-2">
          <Button asChild className="h-10" variant="outline">
            <Link to={paths.dashboard}>
              {t('errors.redirect', { module: t('errors.modules.dashboard') })}
            </Link>
          </Button>
          <Button asChild className="h-10">
            <Link to={paths.documents.root}>
              {t('errors.redirect', { module: t('errors.modules.documents') })}
            </Link>
          </Button>
        </div>
      }
    />
  );
};
